import React, { useState, useEffect } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Card,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { LongText } from "../../../../../Component";
import { formatDate } from "../../../../../Utilities/Functions";

const LatestChecks = (props) => {
  const { classes, data } = props;
  const { t } = useTranslation();

  const [checks, setChecks] = useState([]);

  useEffect(() => {
    setChecks(
      (data || []).map((val) => ({
        label: val["label"],
        text: t("labels.dashboard.latestChecks.recordLine1", {
          lastUpdatedDate: formatDate(val["lastUpdatedDate"]),
          countryName: val["countryName"]
        }),
      }))
    );
  }, [data, t]);

  return (
    <Card
      className={classes.cardContainer}
      variant="outlined"
      elevation={0}
      style={{ height: 660, overflowY: "scroll" }}
    >
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: "1.31rem",
          color: "#464646",
          paddingLeft: 5,
        }}
      >
        {t("labels.dashboard.latestChecks.title")}
      </Typography>
      <List>
        {(checks || []).map((val, index) => {
          return (
            <ListItem key={index} className={classes.latestChecksItem}>
              <ListItemText
                primary={
                  <LongText text={val.label} />
                }
                secondary={val.text}
                width={200} />
            </ListItem>
          );
        })}

        {checks.length < 1 && (
          <Typography style={{ textAlign: "center" }}>
            {t("labels.dashboard.common.noDataMessage")}
          </Typography>
        )}
      </List>
    </Card>
  );
};

export default LatestChecks;
